module.exports = __webpack_public_path__ + "static/media/double-bed.74e209ca.svg";